document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (!toggle) return;
  const menu = document.querySelector('[data-mobile-menu]');
  if (!menu) return;
  const open = menu.toggleAttribute('data-open');
  toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
});

document.addEventListener('change', (event) => {
  if (event.target.matches('[data-variant-select]')) {
    const option = event.target.selectedOptions[0];
    const form = event.target.closest('form');
    const idInput = form && form.querySelector('[name="id"]');
    if (idInput && option) idInput.value = option.value;
  }

  if (!event.target.matches('[data-trio-color], [data-trio-size]')) return;
  const builder = event.target.closest('[data-trio-builder]');
  if (!builder) return;

  const variants = JSON.parse(builder.querySelector('[data-trio-variants]').textContent);
  if (event.target.matches('[data-trio-color]')) {
    const item = event.target.closest('.trio-builder__item');
    const sizeSelect = item.querySelector('[data-trio-size]');
    const colorVariants = variants[event.target.value] || [];
    sizeSelect.innerHTML = '<option value="">Escolha o tamanho</option>';
    colorVariants.forEach((variant) => {
      const size = variant.option1 || variant.title;
      const option = document.createElement('option');
      option.value = size;
      option.textContent = variant.available ? size : `${size} — Esgotado`;
      option.disabled = !variant.available;
      sizeSelect.appendChild(option);
    });
    sizeSelect.disabled = !event.target.value;
  }

  updateTrioBuilder(builder, variants);
});

function updateTrioBuilder(builder, variants) {
  const items = [...builder.querySelectorAll('.trio-builder__item')];
  const selections = items.map((item) => {
    const color = item.querySelector('[data-trio-color]').value;
    const size = item.querySelector('[data-trio-size]').value;
    const variant = (variants[color] || []).find((entry) => (entry.option1 || entry.title) === size && entry.available);
    return { color, size, variant };
  });

  const complete = selections.every((selection) => selection.variant);
  const button = builder.querySelector('[data-trio-add]');
  const message = builder.querySelector('[data-trio-message]');
  button.disabled = !complete;
  button.dataset.items = complete ? JSON.stringify(selections.map((selection) => selection.variant.id)) : '';
  message.textContent = complete ? 'Seu trio está pronto.' : 'Complete as três escolhas para continuar.';

  const trioImage = document.querySelector('[data-trio-image]');
  const colors = selections.map((selection) => selection.color).filter(Boolean);
  if (!trioImage || !colors.length) return;
  if (colors.length === 3 && colors.every((color) => color === 'black')) trioImage.src = trioImage.dataset.trioBlack;
  else if (colors.length === 3 && colors.every((color) => color === 'white')) trioImage.src = trioImage.dataset.trioWhite;
  else if (colors.length === 3 && colors.every((color) => color === 'navy')) trioImage.src = trioImage.dataset.trioNavy;
  else trioImage.src = trioImage.dataset.trioMixed;
}

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-trio-add]');
  if (!button || button.disabled) return;

  const builder = button.closest('[data-trio-builder]');
  const message = builder.querySelector('[data-trio-message]');
  const ids = JSON.parse(button.dataset.items || '[]');
  const quantities = ids.reduce((result, id) => {
    result[id] = (result[id] || 0) + 1;
    return result;
  }, {});

  button.disabled = true;
  button.textContent = 'Adicionando...';

  try {
    const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: Object.entries(quantities).map(([id, quantity]) => ({ id: Number(id), quantity })) })
    });
    if (!response.ok) throw new Error('Não foi possível adicionar o trio.');
    window.location.href = `${root}discount/TRIO60?redirect=/cart`;
  } catch (error) {
    message.textContent = 'Não foi possível adicionar o trio. Atualize a página e tente novamente.';
    button.disabled = false;
    button.textContent = 'Adicionar trio à sacola';
  }
});
